export default __webpack_public_path__ + "static/media/selectEcomsolution.a08553c2.jpg";